import { api } from './client';
import type { Assessment } from './assessment';

export interface TrendPoint {
  cadencePeriod: string;
  userId: string;
  totalScore: number;
  dimensionScores: Record<string, number>;
  submittedAt: string;
}

export async function getTeamScores(): Promise<{ assessments: Assessment[] }> {
  const r = await api.get<{ assessments: Assessment[] }>('/team/scores');
  return r.data;
}

export async function getTeamTrend(): Promise<{ trend: TrendPoint[] }> {
  const r = await api.get<{ trend: TrendPoint[] }>('/team/scores/trend');
  return r.data;
}
